/* eslint-disable lingui/no-unlocalized-strings, lingui/text-restrictions */
import { ArrowRight, ArrowUpRight, Check, Search } from "lucide-react";
import { useState } from "react";
import { Link } from "react-router-dom";

import { useAuthStore } from "@/client/stores/auth";

import { ProjectArtifact, StoryIdentity } from "./career-story";

const connections = [
  {
    label: "Lead with research",
    source: "The observation",
    evidence: "People hesitated at the first decision.",
    explanation:
      "Avery’s onboarding research gives them a specific example to discuss for a role that values discovery.",
  },
  {
    label: "Turn insight into design",
    source: "The decision",
    evidence: "Replace a long guide with one guided next step.",
    explanation:
      "The project connects a user insight to a design choice. Avery can explain both the reasoning and the trade-off.",
  },
  {
    label: "Work across functions",
    source: "The collaboration",
    evidence: "Test the prototype before committing to the build.",
    explanation:
      "Avery can use this project to talk about working with research and engineering to choose what to build.",
  },
];

export const DailyHabitSection = () => {
  const { user } = useAuthStore();
  const [selected, setSelected] = useState(0);
  const connection = connections[selected];
  return (
    <section id="job-matching" className="folio-section folio-roles">
      <div className="folio-shell">
        <div className="folio-section-heading">
          <div>
            <p className="folio-eyebrow">Find your next opportunity</p>
            <h2>Found a role? Prepare for that role.</h2>
          </div>
          <p>
            Search for jobs using your resume or keywords. Choose a role and launch interview
            practice with that job’s context, so your preparation has a clear focus.
          </p>
        </div>
        <div className="role-workbench">
          <div className="role-requirements">
            <p className="folio-label">
              <Search size={14} /> Illustrative role
            </p>
            <h3>Product designer</h3>
            <p className="role-meta">Customer experience · Discovery</p>
            <p className="role-instruction">Choose a requirement to explore</p>
            <div className="role-options">
              {connections.map((item, index) => (
                <button
                  type="button"
                  key={item.label}
                  aria-pressed={selected === index}
                  aria-controls="role-connection"
                  onClick={() => setSelected(index)}
                >
                  <span>0{index + 1}</span>
                  {item.label}
                  <ArrowRight size={16} />
                </button>
              ))}
            </div>
          </div>
          <div className="role-connection" id="role-connection" aria-live="polite">
            <StoryIdentity detail="Onboarding project · illustrative example" />
            <div className="role-evidence">
              <span className="folio-label">{connection.source}</span>
              <h3>{connection.evidence}</h3>
              <p>{connection.explanation}</p>
            </div>
            <p className="role-connection-note">
              <Check size={15} /> One project. Several relevant things to talk about.
            </p>
          </div>
          <div className="role-project">
            <ProjectArtifact />
          </div>
        </div>
        <div className="folio-section-bottom">
          <span className="folio-example-note">An example of connecting experience to a role.</span>
          <Link className="folio-text-link" to={user ? "/dashboard/jobs" : "/auth/register"}>
            Find a job to practice for <ArrowUpRight size={17} />
          </Link>
        </div>
      </div>
    </section>
  );
};
